const calpak = window.calpak

// Moved file to main-deferred.js, so removed DOMContendLoaded event

/**
 * Gets keyboard-focusable elements within a specified element
 *
 * @see https://zellwk.com/blog/keyboard-focusable-elements/
 * @see https://allyjs.io/data-tables/focusable.html
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
function getKeyboardFocusableElements(element = document) {
  return [...element.querySelectorAll('a[href],button,input,textarea,select,details,[tabindex]:not([tabindex="-1"]),data-focusable')].filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden")
  );
}

let searchPlaceholders = document.querySelectorAll(".search-placeholders");
if (searchPlaceholders.length > 0) {
  const searchPlaceholdersTimeout = 3000;

  function restoreSearchPlaceholder(searchPlaceholder) {
    setTimeout(() => searchPlaceholder.classList.add("search-placeholders--no-anim"), 520);
    setTimeout(() => searchPlaceholder.style.setProperty("--page", 0), 570);
    setTimeout(() => searchPlaceholder.classList.remove("search-placeholders--no-anim"), 620);
  }

  setInterval(() => {
    for (let i = 0; i < searchPlaceholders.length; i++) {
      const num = parseInt(searchPlaceholders[i].getAttribute("data-num"));
      let page = searchPlaceholders[i].style.getPropertyValue("--page");
      page++;
      searchPlaceholders[i].style.setProperty("--page", page);

      if (page >= num) {
        page = 0;
        restoreSearchPlaceholder(searchPlaceholders[i]);
      }
    }
  }, searchPlaceholdersTimeout);
}

const headerOverlay = document.querySelector(".site-header__overlay");
if (headerOverlay)
  headerOverlay.addEventListener("click", () => {
    let closeLink = document.querySelector(".menu-popup--visible .menu-close");
    if (closeLink) closeLink.click();
  });

let menuActivators = document.querySelectorAll(".menu-popup__activator");
for (let i = 0; i < menuActivators.length; i++)
  menuActivators[i].addEventListener("click", function (e) {
    e.preventDefault();
    const target = this.getAttribute("data-target");
    const header = document.querySelector(".shopify-section--header");
    const menu = document.querySelector('.menu-popup[data-id="' + target + '"]');

    if (!menu) return;

    if (menu.classList.contains("menu-popup--visible")) {
      menu.classList.remove("menu-popup--visible");
      menu.setAttribute("aria-selected", "false");
      menu.setAttribute("tabindex", "-1");
      setTimeout(() => header.removeAttribute("data-menu"), 500);
      document.body.classList.remove("modal-open");
      document.body.classList.remove("menu-modal-open");
      document.querySelector(".menu-popup__content").classList.remove("dashed-border");
      menuActivators[i].classList.remove("dashed-border");
      return;
    }

    const actives = document.querySelectorAll(".menu-popup--visible");
    for (let i = 0; i < actives.length; i++) {
      actives[i].classList.remove("menu-popup--visible");
      actives[i].setAttribute("aria-selected", "false");
      actives[i].setAttribute("tabindex", "-1");
      menu.setAttribute("aria-selected", "false");
      menu.setAttribute("tabindex", "-1");
    }

    if (actives.length > 0) {
      setTimeout(() => {
        header.setAttribute("data-menu", target);
        setTimeout(() => {
          menu.classList.add("menu-popup--visible");
          menu.setAttribute("aria-selected", "true");
          menu.setAttribute("tabindex", "0");
        }, 5);
      }, 300);
    } else {
      header.setAttribute("data-menu", target);
      document.body.classList.add("modal-open");
      document.body.classList.add("menu-modal-open");
      setTimeout(() => {
        document.querySelector(".menu-popup__content").classList.add("dashed-border");
        menuActivators[i].classList.add("dashed-border");
      }, 300);
      setTimeout(() => {
        menu.classList.add("menu-popup--visible");
        menu.setAttribute("aria-selected", "true");
        menu.setAttribute("tabindex", "0");
      }, 5);
    }

    if (menu.classList.contains("menu-popup--shop")) {
      menu.querySelector(".slider").removeAttribute("aria-hidden");
      let headerSlides = menu.querySelectorAll(".slide:not(.product-unit)");
      [].map.call(headerSlides, (slide) => {
        slide.setAttribute("tabindex", "0");
      });
    }

  });

let menuDeactivators = document.querySelectorAll(".menu-close--shop, .menu-close--mobile-menu, .menu-close--discover, .menu-close--search");
menuDeactivators.forEach((menuDeactivator) =>
  menuDeactivator.addEventListener("click", function () {
    const menuPopup = this.closest(".menu-popup");
    const menuPopupActivator = menuPopup?.activator ?? menuPopup?.parentNode?.querySelector(".menu-popup__activator");
    const header = document.querySelector(".shopify-section--header");

    if (menuPopup) {
      if (menuPopup.classList.contains("menu-popup--shop")) {
        menuPopup.querySelector(".slider").setAttribute("aria-hidden", "true");
        let headerSlides = menuPopup.querySelectorAll(".slide");
        [].map.call(headerSlides, (slide) => {
          slide.setAttribute("tabindex", "-1");
        });
      }
    }

    if (menuPopup) {
      menuPopup.classList.remove("menu-popup--visible");
      menuPopup.setAttribute("aria-selected", "false");
      menuPopup.setAttribute("tabindex", "-1");
    }

    if (window.innerWidth > 900) {
      setTimeout(() => header.removeAttribute("data-menu"), 500);
      menuPopupActivator?.setAttribute("aria-selected", "false");
    }

    document.body.classList.remove("modal-open");
    document.body.classList.remove("menu-modal-open");
    document.querySelector(".menu-popup__content").classList.remove("dashed-border");
    document.querySelector(".menu-popup__activator")?.classList.remove("dashed-border");
    menuPopupActivator?.focus();

    const searchLink = document.querySelector(".header__search-link");
    if(searchLink) searchLink.removeAttribute("aria-selected");
  })
);

document.querySelector(".menu-close--mobile-menu").onclick = () => {
  document.querySelector(".shopify-section--header")?.removeAttribute("data-menu");
  document.querySelectorAll(".mobile-menu__activator").forEach(item=>item.focus());
  document.querySelectorAll(".mobile-menu__activator").forEach(item=>item.setAttribute("aria-expanded", "false"));
};

let subnavActivators = document.querySelectorAll(".subnav__activator");
for (let i = 0; i < subnavActivators.length; i++)
  subnavActivators[i].addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    this.closest(".subnav__container").classList.toggle("site-header__dropdown--active");
    if (this.closest(".subnav__container").classList.contains("site-header__dropdown--active")) {
      this.setAttribute("aria-expanded", "true");
    } else {
      this.setAttribute("aria-expanded", "false");
    }
  });

const notifiactionsActivators = document.querySelectorAll(".header__notifications-link");
const notifiactionPopup = document.querySelector(".notifications-popup");
calpak.previousElement = document.activeElement || document.body;

if (notifiactionsActivators.length > 0 && notifiactionPopup) {
  let unseenNotifications = 0;
  const activeNotifications = [];
  const seenNotifications = JSON.parse(localStorage.getItem("notificationsSeen") || "[]");
  const notifications = document.querySelectorAll(".notifications-popup .notification");

  if (notifications.length > 0) {
    notifications.forEach((notification) => activeNotifications.push(notification.getAttribute("data-id")));
  }

  activeNotifications.forEach((activeNotification) => {
    if (seenNotifications.indexOf(activeNotification) === -1) {
      unseenNotifications++;
    }
  });

  if (unseenNotifications > 0) {
    document.body.classList.add("notifications-unread");
  }

  notifiactionsActivators.forEach((notifiactionsActivator) =>
    notifiactionsActivator.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      calpak.closeAllDropdowns();
      notifiactionPopup.classList.add("notifications-popup--active");
      notifiactionPopup.setAttribute("role", "dialog");
      notifiactionPopup.setAttribute("aria-modal", "true");
      setTimeout(() => {
        localStorage.setItem("notificationsSeen", JSON.stringify(activeNotifications));
        document.body.classList.remove("notifications-unread");
      }, 500);
      e.target.focus();
      calpak.previousElement = document.activeElement || document.body;
      if (notifiactionPopup.classList.contains("notifications-popup--active")) {
        document.querySelector(".menu-close--notifications").focus();
      } else {
        document.querySelector("#shop__mobile_tab").focus();
      }
    })
  );
  notifiactionPopup.querySelector(".menu-close--notifications").addEventListener("click", function (e) {
    e.preventDefault();
    notifiactionPopup.classList.remove("notifications-popup--active");
    calpak.previousElement.focus();
    calpak.previousElement = null;
  });
  notifiactionPopup.addEventListener("keydown", function (e) {
    const focusableElements = getKeyboardFocusableElements(notifiactionPopup);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    const currentFocus = e.target;
    const closeButton = notifiactionPopup.querySelector(".menu-close--notifications");
    const is_first_focusable = currentFocus === firstFocusableElement;
    const is_last_focusable = currentFocus === lastFocusableElement;

    if (e.key == "Escape") {
      e.preventDefault();
      closeButton.click();
    }
    if (e.key == "Tab" && e.shiftKey && is_first_focusable) {
      e.preventDefault();
      lastFocusableElement.focus();
    }
    if (e.key == "Tab" && !e.shiftKey && is_last_focusable) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });
}

const notificationsPopup = document.querySelector(".notifications-popup");
if (notificationsPopup) notificationsPopup.addEventListener("click", (e) => e.stopPropagation());

document.querySelectorAll(".mobile-menu__activator").forEach(item=>item.addEventListener("click", async function (e) {
  e.preventDefault();
  calpak.openMenu("mobile-menu");
}));

// ADA swatches keyboard navigation
function customMobileTabNavigation() {
  const swatchesKeyContainerUnit = document.querySelectorAll("#nav-header-bottom");
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customMobileKeyNav(container);
  });
}
setTimeout(() => {
  customMobileTabNavigation();
}, 500);

/* GENERAL RADIO BUTTONS KAYBOARD NAVIGATION */
function customMobileKeyNav(container) {
  container.addEventListener("keyup", function (e) {
    let colorButtons = container.querySelectorAll(".menu-popup__activator");
    [].map.call(colorButtons, (colorButton) => {
      colorButton.addEventListener("click", function (e) {
        selectColorButton(e.target);
      });
    });

    switch (e.key) {
      case "ArrowUp":
      case "ArrowLeft":
        e.preventDefault();
        selectPreviousColorButton(e.target);
        break;

      case "ArrowDown":
      case "ArrowRight":
        e.preventDefault();
        selectNextColorButton(e.target);
        break;

      case " ":
        selectColorButton(e.target);
        break;
    }
    // secondary functions
    function selectPreviousColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index > 0) {
        selectColorButton(colorButtons[index - 1]);
      } else {
        selectColorButton(colorButtons[colorButtons.length - 1]);
      }
    }

    function selectNextColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index < colorButtons.length - 1) {
        selectColorButton(colorButtons[index + 1]);
      } else {
        selectColorButton(colorButtons[0]);
      }
    }

    function selectColorButton(colorButton) {
      // Deselect all other color buttons
      colorButtons.forEach(function (otherColorButton) {
        otherColorButton.setAttribute("tabindex", "-1");
        otherColorButton.setAttribute("aria-checked", false);
      });

      // Select the provided color button
      colorButton.setAttribute("tabindex", "0");
      colorButton.setAttribute("aria-checked", true);
      colorButton.focus();
    }
  });
}

const updateMoreinfoContent = function() {
  let moreButtonWrap = document.querySelector(".moreBTN_wrap");
  moreButtonWrap.classList.add("showFull");
}
calpak.updateMoreinfoContent = updateMoreinfoContent

//  document.querySelector('.mobile-menu__activator.burger-link').addEventListener('click', function() {
//     document.querySelector('.header__bag-link').classList.add('active');
//     document.querySelector('.site-header__menu-item.search-item').classList.add('active');
//     document.querySelector('.site-header__mobile.search-item').style.display = "none";
//     document.querySelector('.promo-bar-text-container').style.display = "none";

// });
// document.querySelector('.menu-close.menu-close--mobile-menu').addEventListener('click', function() {
//     document.querySelector('.header__bag-link').classList.remove('active');
//     document.querySelector('.site-header__menu-item.search-item').classList.remove('active');
//     document.querySelector('.site-header__mobile.search-item').style.display = "block";
//     document.querySelector('.promo-bar-text-container').style.display = "block";
// });

const intervalBottomNavigation = setInterval(() => {
  const experiment = window?.igData?.user?.getTestGroup('2086d324-7087-4c97-b723-2448a9a91104');
    if (experiment) {
      const { name } = experiment ?? {}
    
      switch (name) {
        case 'Original':
          window.addEventListener("scroll", () => {
            let proH = 0;
            let sH = 0;
          
            if (document.querySelector(".shopify-section-promo-bar")) {
              proH = document.querySelector(".shopify-section-promo-bar").clientHeight;
            }
          
            if(typeof window.motherDayGamification != 'undefined')
            {
              proH += document.querySelector("#shopify-section-mother-day-promo-header").clientHeight;
            }
          
            if (document.querySelector(" .site-header__nav")) {
              sH = document.querySelector(" .site-header__nav").clientHeight;
            }
            if (document.documentElement.scrollTop >= proH + sH) {
              document.querySelector(".site-header").classList.add("sticked");
            } else {
              document.querySelector(".site-header").classList.remove("sticked");
            }
          });
          break
        case 'Variant':
          const topRibbon = document.getElementById("shopify-section-promo-bar");
          const heightTopRibbon = topRibbon.clientHeight;
          const headerNew = document.getElementById('shopify-section-header-new');
          const headerNewBotton = document.getElementById('shopify-section-header-bottom-navigation');
          
          document.documentElement.style.setProperty('--height-top-ribbon', `${heightTopRibbon}px`);
          document.documentElement.style.setProperty('--notifications-popup-bottom', `${headerNewBotton.clientHeight}px`);
          
          document.querySelector(".site-header-bottom .mobile-menu__activator")?.addEventListener("click", async function (e) {
            e.preventDefault();
            calpak.openMenu("mobile-menu");
          });
          
          function functionalityHeader() {
            const arePromotionBar = !document.querySelector("body").classList.contains('promo-bar-hidden');
            const notificationsPopup = document.querySelector('.notifications-popup.notifications-popup--active');
            let proH = 0;
            let sH = 0;
          
            // Add Global-E banner height to promo height (it should scroll away like promo banners)
            const globalEBanner = document.querySelector("#FreeShippingBanner");
            if (globalEBanner) {
              proH += globalEBanner.offsetHeight;
            }
          
            if (document.querySelector(".shopify-section-promo-bar")) {
              proH += heightTopRibbon;
            }
          
            if(typeof window.holidayGamification != 'undefined')
            {
              proH += document.querySelector("#shopify-section-holiday-gamification-header").clientHeight;
            }
          
            if (document.querySelector(" .site-header__nav")) {
              sH = document.querySelector(" .site-header__nav").clientHeight;
            }
            // Trigger sticky as soon as header reaches top (after all promo content scrolls away)
            if (document.documentElement.scrollTop >= proH) {
              document.querySelector(".site-header").classList.add("sticked");
              if(arePromotionBar){
                topRibbon.classList.add("top-of");
                headerNew.classList.add("top-of");
              }
              headerNewBotton.classList.add("go-down");
              if (notificationsPopup) notificationsPopup.style.bottom = '';
            } else {
              document.querySelector(".site-header").classList.remove("sticked");
              if(arePromotionBar){
                topRibbon.classList.remove("top-of");
                headerNew.classList.remove("top-of");
              }
              headerNewBotton.classList.remove("go-down");
              if (notificationsPopup) notificationsPopup.style.bottom = '0px';
            }
          }
          
          window.addEventListener("scroll", () => {
            functionalityHeader()
          });
          break
        default:
          break
      }
    } else {
      window.addEventListener("scroll", () => {
        let proH = 0;
        let sH = 0;
      
        // Add Global-E banner height to promo height (it should scroll away like promo banners)
        const globalEBanner = document.querySelector("#FreeShippingBanner");
        if (globalEBanner) {
          proH += globalEBanner.offsetHeight;
        }
      
        if (document.querySelector(".shopify-section-promo-bar")) {
          proH += document.querySelector(".shopify-section-promo-bar").clientHeight;
        }
      
        if(typeof window.motherDayGamification != 'undefined')
        {
          proH += document.querySelector("#shopify-section-mother-day-promo-header").clientHeight;
        }
      
        if (document.querySelector(" .site-header__nav")) {
          sH = document.querySelector(" .site-header__nav").clientHeight;
        }
        // Trigger sticky as soon as header reaches top (after all promo content scrolls away)
        if (document.documentElement.scrollTop >= proH) {
          document.querySelector(".site-header").classList.add("sticked");
        } else {
          document.querySelector(".site-header").classList.remove("sticked");
          if(document.querySelector(".notifications-popup.notifications-popup--active"))
          document.querySelector(".notifications-popup.notifications-popup--active").style.top = (proH + sH - document.documentElement.scrollTop) + "px";
        }
      });
    }

    clearInterval(intervalBottomNavigation);

    return;
}, 100);


const header_li = document.querySelectorAll("#nav-header-bottom li");
const close_btn = document.querySelectorAll(".menu-close");
header_li.forEach((arr) => {
  arr.addEventListener("click", () => {
    document.querySelector(".site-header__nav.right").classList.add("active");
  });
});
close_btn.forEach((arr) => {
  arr.addEventListener("click", () => {
    document.querySelector(".site-header__nav.right").classList.remove("active");
  });
});

const search_link = document.querySelectorAll(".search-query-wrap");
document.querySelector(".search-input").addEventListener("change", (e) => {
  search_link.forEach((arr) => {
    arr.innerHTML = e.target.value;
  });
});

// show menu and cart nav buttons when their functions have loaded (deferred)
document.querySelectorAll(".mobile-menu__activator img, .header__search-link img, .open-cart-link dynamic").forEach((element) => {
  element.classList.remove("hidden")
});
